export const limitCharacters = (text = '', limit = 45) => {
    return (text.length <= limit) ? `${text.slice(0, limit)}` : `${text.slice(0, limit)}...`
}